

import _config from '../_config';
import Axios from 'axios';
import { authHeader } from '../_helpers/auth-header';
export const apiService = {
    type: function (route) {
        const requestOptions = { headers: authHeader() };
        return Axios.get(`${_config.baseUrl}/api/user/${route}/b/user/type`, requestOptions).then(handleResponse);
    },
    getAll: function (route) {
        const requestOptions = { headers: authHeader() };
        return Axios.get(`${_config.baseUrl}/api/user/${route}`, requestOptions).then(handleResponse);
    },
    filter: function (route, data) {
        const requestOptions = { headers: authHeader() };
        return Axios.post(`${_config.baseUrl}/api/user/${route}/filter`, data, requestOptions).then(handleResponse);
    },
    filterNear: function (route, data) {
        const requestOptions = { headers: authHeader() };
        return Axios.post(`${_config.baseUrl}/api/user/${route}/nearby`, data, requestOptions).then(handleResponse);
    },
    getSingle: function (route, id) {
        const requestOptions = { headers: authHeader() };
        return Axios.get(`${_config.baseUrl}/api/user/${route}/${id}`, requestOptions).then(handleResponse);
    },
    add: function (route, data) {
        const requestOptions = { headers: authHeader() };
        return Axios.post(`${_config.baseUrl}/api/user/${route}`, data, requestOptions).then(handleResponse);
    },
    update: function (route, data, id) {
        const requestOptions = { headers: authHeader() };
        return Axios.put(`${_config.baseUrl}/api/user/${route}/${id}`, data, requestOptions).then(handleResponse);
    },
    delete: function (route, id) {
        const requestOptions = { headers: authHeader() };
        return Axios.delete(`${_config.baseUrl}/api/user/${route}/${id}`, requestOptions).then(handleResponse);
    }
};




function handleResponse(response) {
    return response.data;
}